import React, { useCallback, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { getCompletedSubtaskIdsByTaskId } from "~/store/selectors/selector.subtasks.jsx";
import CompletedSubtasksList from "./CompletedSubtasksList.jsx";

export const CompletedSubtasksContainer = ({ taskId, isTaskCompleted }) => {
  const { t } = useTranslation();
  const subtaskIds = useSelector((state) => getCompletedSubtaskIdsByTaskId(state, taskId));
  const [show, setShow] = useState(false);

  const handleToggleCompletedSubtasks = useCallback(
    (e) => {
      e.preventDefault();
      setShow(!show);
    },
    [show]
  );

  const items = useMemo(() => {
    if (show) {
      return subtaskIds;
    }
    return subtaskIds.slice(0, 3);
  }, [show, subtaskIds]);

  const completedLabel = useMemo(() => {
    if (!show) {
      const count = subtaskIds.length - 3;
      if (count === 1) {
        return t("Show 1 more completed subtasks");
      }
      return t("Show {{numberOfCompletedTasks}} more completed subtasks", {
        numberOfCompletedTasks: count,
      });
    }

    return t("Hide completed subtasks");
  }, [t, subtaskIds, show]);

  if (!items.length) return null;

  return (
    <div className="tw-pt-2">
      <CompletedSubtasksList
        subtaskIds={items}
        isTaskCompleted={isTaskCompleted}
      />
      {subtaskIds.length > 3 && (
        <button
          className="completed_subtask_toggler"
          onClick={handleToggleCompletedSubtasks}
        >
          {completedLabel}
        </button>
      )}
    </div>
  );
};

CompletedSubtasksContainer.propTypes = {
  taskId: PropTypes.number.isRequired,
  isTaskCompleted: PropTypes.bool,
};

CompletedSubtasksContainer.defaultProps = {
  isTaskCompleted: false,
};
